module.exports = __webpack_public_path__ + "static/media/logo.45d19cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/strata/images/logo.png
// module id = 356
// module chunks = 0